import { useCallback } from 'react';
import { useAppSelector } from 'stores';

function usePermission() {
  const user = useAppSelector((s) => s.auth.user);

  return useCallback(
    (code: string) => !!user && user.permissions.includes(code),
    [user],
  );
}

export default usePermission;
